export default __webpack_public_path__ + "static/media/source-sans-pro-v12-latin-700.9dff9dc0.woff";